import { type AuthHeader, useAuthHeader } from "@roman/shared/hooks/useAuthHeader";
import romanApi, { type RomanApiError } from "@roman/shared/lib/net/romanApi";
import useSWRMutation from "swr/mutation";
import { useHandleError } from "../useHandleError";

type Arg = {
  name: string;
};

const fetcher = (url: string, headers: AuthHeader, { arg }: { arg: Arg }) => romanApi.patch(url, arg, { headers });

export const useUpdateWebUser = (
  handleError: (err: RomanApiError) => void = useHandleError("ユーザーの更新に失敗しました"),
) => {
  const header = useAuthHeader();
  const { data, error, trigger, isMutating } = useSWRMutation(
    "/user/me",
    (url: string, args: { arg: Arg }) => fetcher(url, header, args),
    {
      onError: () => {
        handleError(error);
      },
    },
  );

  return {
    data,
    error,
    isMutating,
    updateWebUser: trigger,
  };
};
